<template>
  <div id="schedule">
    <h3>PROGRAM</h3>
    <p>Aruncă un ochi peste program</p>
    <div class="schedule-columns">
      <div class="day-card" v-for="(dayData, index) in schedule" :key="index">
        <h1>{{ dayData.day }}</h1>
        <h2>{{ dayData.date }}</h2>
        <hr />
        <div
          class="day-schedule"
          v-for="(training, index) in dayData.trainings"
          :key="index"
        >
          <span id="traings-interval">{{ training.hourlyIntervals }}</span>
          <span class="trainings-element" v-html="training.training"></span>
          <hr />
        </div>
      </div>
    </div>
    <img :src="path" class="wave" />
  </div>
</template>

<script>
import schedule from "@/assets/resources/schedule.js";

export default {
  props: ["multiline"],
  data() {
    return {
      schedule,
      path: require("@/assets/images/PathTrainers.svg"),
    };
  },
};
</script>

<style lang="scss" scoped>
#schedule {
  background-color: #0d2a4c;
  padding-top: 10vh;
  padding-bottom: 10vh;
  position: relative;
  overflow: hidden;
}

.schedule-columns {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

h1,
h3,
p,
h2,
span,
strong,
hr {
  color: #edf6fb;
  font-family: "Acumin Variable Concept";
}

h1 {
  font-size: calc(
    (70 - 14) * ((100vw - 300px) / (3840 - 300))
  ); //this is wrong, it should have a +14 after the first paranthesis, but somehow it works so leave it alone
  margin-top: 2vh;
  margin-bottom: 0;
}

h2 {
  font-size: calc((50 - 10) * ((100vw - 300px) / (3840 - 300)));
  margin-bottom: 0.7vh;
  opacity: 0.8;
}

h3,
p {
  width: 100%;
  margin-left: 7vw;
  text-align: left;
}

h3 {
  font-weight: 400;
  font-size: calc((160 - 40) * ((100vw - 300px) / (3840 - 300)));
}

p {
  margin-bottom: 15vh;
  font-size: calc((130 - 40) * ((100vw - 300px) / (3840 - 300)));
  font-family: "century-gothic";
}

hr {
  width: 80%;
  margin: auto;
  margin-bottom: 2vh;
  height: 2px;
  opacity: 0.4;
}

.trainings-element {
  display: block;
  margin: auto;
  text-align: center;
  width: 86%;
  font-weight: 500;
  margin-bottom: 1.2vh;
  font-size: calc((50 - 10) * ((100vw - 300px) / (3840 - 300)));
}

#traings-interval {
  font-size: calc((50 - 10) * ((100vw - 300px) / (3840 - 300)));
  font-weight: 100;
  opacity: 0.8;
}

.day-card {
  text-align: center;
  position: relative;
  width: 11vw;
  margin-right: 0.6vw;
  margin-left: 0.6vw;
  padding-bottom: 12vh;
  border-radius: 2.5vw 2.5vw 0 0;
  border: 1px #707070;
  height: 80%;
}

.day-card:nth-child(1) {
  top: 2.5vh;
  background-color: rgba(13, 149, 154, 1);
}

.day-card:nth-child(2) {
  top: -2vh;
  background-color: rgba(13, 149, 154, 0.77);
}

.day-card:nth-child(3) {
  top: -4.5vh;
  background-color: rgba(13, 149, 154, 0.7);
}

.day-card:nth-child(4) {
  background-color: rgba(13, 149, 154, 0.7);
  top: 0.5vh;
}

.day-card:nth-child(5) {
  top: 4vh;
  background-color: rgba(13, 149, 154, 0.91);
}

.day-card:nth-child(6) {
  background-color: rgba(13, 149, 154, 0.85);
  top: 7vh;
}

.day-card:nth-child(7) {
  background-color: rgba(13, 149, 154, 1);
  top: 2vh;

  .trainings-element {
    margin-bottom: 0.5vh;
  }
}

.wave {
  position: absolute;
  bottom: 0;
}

@media screen and (max-width: 1024px) {
  #schedule {
    padding-bottom: 0;
  }

  p,
  h3 {
    margin-left: 10vw;
  }

  h3 {
    font-size: 7vw;
  }

  p {
    font-size: 5vw;
    margin-bottom: 4vh;
  }

  hr {
    margin: auto;
    margin-bottom: 2vh;
    width: 70%;
    height: 1px;
    opacity: 0.3;
  }

  h1 {
    margin-top: 2vh;
    font-size: 5vw;
  }

  .wave {
    display: none;
  }

  .trainings-element {
    font-size: 3.5vw;
  }

  #traings-interval,
  h2 {
    font-size: 2.5vw;
  }

  .schedule-columns {
    justify-content: space-evenly;
    align-items: stretch;//din motive nu merge
  }

  .schedule-columns > .day-card {
    top: 0;
  }

  .day-card {
    border-radius: 5vw;
    margin: 2.5vw;
    padding: 0;
    display: inline-block;
    width: 40vw;
    height: 100%;
  }
  //nu este deloc elaganta varianta asta dar nu mai stau la ea
  .day-card:nth-child(2) {
    padding-bottom: 2.3vh;
  }
    .day-card:nth-child(4) {
    padding-bottom: 2.3vh;
  }
}
</style>
